import { IPremadeQuiz } from '@quizzach/interfaces';

/** i18n key for a premade difficulty level (1–3), null when unset. */
export const premadeLevelKey = (level?: number) =>
	level === 1
		? 'premade.single.levelEasy'
		: level === 2
			? 'premade.single.levelMedium'
			: level === 3
				? 'premade.single.levelHard'
				: null;

export const sortQuizzesNewestFirst = (quizzes: IPremadeQuiz[] = []) =>
	[...quizzes].sort(
		(firstQuiz, secondQuiz) =>
			(secondQuiz.created_at ?? 0) - (firstQuiz.created_at ?? 0)
	);
